// Sample gallery data. Replace imageUrl entries with your own assets later.
export const GALLERY_ITEMS = [
  {
    id: 'achv-01',
    type: 'image',
    title: 'AI Innovation Award 2025',
    description: 'Recognized for our breakthrough in scalable AI Ops.',
    tags: ['Achievements', 'Awards'],
    date: '2025-11-08',
    imageUrl: 'https://picsum.photos/id/1015/800/600',
  },
  {
    id: 'launch-01',
    type: 'image',
    title: 'MASRIQ Cloud Launch',
    description: 'Introducing our unified cloud orchestration platform.',
    tags: ['Launches', 'Products'],
    date: '2025-09-21',
    imageUrl: 'https://picsum.photos/id/1025/800/600',
  },
  {
    id: 'event-01',
    type: 'image',
    title: 'Tech Expo Showcase',
    description: 'Live demo of real-time analytics and ML pipelines.',
    tags: ['Events', 'Community'],
    date: '2025-08-10',
    imageUrl: 'https://picsum.photos/id/1035/800/600',
  },
  {
    id: 'achv-02',
    type: 'image',
    title: 'ISO 27001 Certification',
    description: 'Security-first operations validated by global standards.',
    tags: ['Achievements', 'Compliance'],
    date: '2025-06-15',
    imageUrl: 'https://picsum.photos/id/1045/800/600',
  },
  {
    id: 'launch-02',
    type: 'image',
    title: 'Edge AI Toolkit',
    description: 'Lightweight toolkit for on-device inference at scale.',
    tags: ['Launches', 'Products'],
    date: '2025-05-02',
    imageUrl: 'https://picsum.photos/id/1055/800/600',
  },
  {
    id: 'event-02',
    type: 'image',
    title: 'Hackathon Winners',
    description: 'Celebrating our team’s sprint to innovative solutions.',
    tags: ['Events', 'Community'],
    date: '2025-04-12',
    imageUrl: 'https://picsum.photos/id/1065/800/600',
  },
  {
    id: 'award-01',
    type: 'image',
    title: 'Top Startup Recognition',
    description: 'Honored among the fastest-growing tech ventures.',
    tags: ['Achievements', 'Awards'],
    date: '2025-03-03',
    imageUrl: 'https://picsum.photos/id/1075/800/600',
  },
  {
    id: 'community-01',
    type: 'image',
    title: 'Open Source Contributions',
    description: 'Proud supporters and maintainers of OSS projects.',
    tags: ['Community'],
    date: '2025-02-18',
    imageUrl: 'https://picsum.photos/id/1085/800/600',
  },
  {
    id: 'launch-03',
    type: 'image',
    title: 'Neural Systems v2',
    description: 'Major release: performance and UX upgrades.',
    tags: ['Launches', 'Products'],
    date: '2025-01-20',
    imageUrl: 'https://picsum.photos/id/1095/800/600',
  },
  {
    id: 'event-03',
    type: 'image',
    title: 'Community Meetup',
    description: 'Sharing knowledge, challenges, and future roadmap.',
    tags: ['Events', 'Community'],
    date: '2024-12-11',
    imageUrl: 'https://picsum.photos/id/1105/800/600',
  },
  {
    id: 'award-02',
    type: 'image',
    title: 'Design Excellence',
    description: 'Awarded for delightful, accessible user experiences.',
    tags: ['Achievements', 'Awards'],
    date: '2024-10-30',
    imageUrl: 'https://picsum.photos/id/1115/800/600',
  },
  {
    id: 'community-02',
    type: 'image',
    title: 'Developer Advocacy',
    description: 'Mentoring and enabling the next generation of builders.',
    tags: ['Community'],
    date: '2024-09-19',
    imageUrl: 'https://picsum.photos/id/1125/800/600',
  },
  // Video entries
  {
    id: 'video-01',
    type: 'video',
    title: 'Launch Teaser — MASRIQ Cloud',
    description: 'A quick teaser showcasing the highlights of our cloud platform.',
    tags: ['Videos', 'Launches'],
    date: '2025-09-10',
    videoUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
    posterUrl: 'https://picsum.photos/id/1005/800/600',
    previewUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
  },
  {
    id: 'video-02',
    type: 'video',
    title: 'Event Recap — Tech Expo',
    description: 'Highlights from our live demo and booth interactions.',
    tags: ['Videos', 'Events'],
    date: '2025-08-15',
    embedUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
    posterUrl: 'https://picsum.photos/id/1011/800/600',
    previewUrl: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
  },
];

export const ALL_TAG = 'All';
